import React from 'react';
import PropTypes from 'prop-types';
import { Pagination, Button } from 'react-bootstrap';
import ReactJsonTree from 'react-json-tree';
import { ClickAwayListener, Tooltip } from '@material-ui/core';
import copyToClipboard from 'copy-to-clipboard';

const theme = {
    scheme: 'monokai',
    author: 'wimer hazenberg (http://www.monokai.nl)',
    base00: '#272822',
    base01: '#383830',
    base02: '#49483e',
    base03: '#75715e',
    base04: '#a59f85',
    base05: '#f8f8f2',
    base06: '#f5f4f1',
    base07: '#f9f8f5',
    base08: '#f92672',
    base09: '#fd971f',
    base0A: '#f4bf75',
    base0B: '#a6e22e',
    base0C: '#a1efe4',
    base0D: '#66d9ef',
    base0E: '#ae81ff',
    base0F: '#cc6633'
};

export class JsonView extends React.PureComponent {
    state = {
        mode: 1,
        openCopyUrlTooltip: false,
    };

    selectMode = mode => () => {
        this.setState({ mode });
    }

    shouldExpandNode = (keyName, data, level) => {
        return level <= (this.props.defaultDepth || 2);
    }

    valueRenderer = (str, raw, key) => {
        if (/uuid$/i.test(key)) {
            return <a href={`/user/${raw}`} target='_blank' rel='noopener noreferrer'>{str}</a>;
        }
        if (/time$/i.test(key) || /created_at$/i.test(key) || /updated_at$/i.test(key)) {
            const date = new Date(raw);
            if (!isNaN(date.getTime())) {
                return `${str} (${new Date(raw).toLocaleString()})`;

            }
        }
        return str;
    }

    handleCloseCopyUrlTooltip = () => {
        this.setState({ openCopyUrlTooltip: false });
    }

    handleCopyToClipboard = () => {
        copyToClipboard(JSON.stringify(this.props.value, null, 4));
        this.setState({ openCopyUrlTooltip: true });
    }

    render() {
        return (
            <div>
                <Pagination>
                    <Pagination.Item key={1} active={this.state.mode === 1} onClick={this.selectMode(1)}>
                        Tree View
                    </Pagination.Item>
                    <Pagination.Item key={2} active={this.state.mode === 2} onClick={this.selectMode(2)}>
                        Raw Json View
                    </Pagination.Item>
                    <ClickAwayListener onClickAway={this.handleCloseCopyUrlTooltip}>
                        <Tooltip open={this.state.openCopyUrlTooltip} title="Copied!">
                            <Button variant="light" onClick={this.handleCopyToClipboard}>Copy to Clipboard</Button>
                        </Tooltip>
                    </ClickAwayListener>
                </Pagination>
                {
                    this.state.mode === 1 &&
                    <ReactJsonTree data={this.props.value} shouldExpandNode={this.shouldExpandNode} theme={theme} invertTheme={true} valueRenderer={this.valueRenderer} />
                }
                {
                    this.state.mode === 2 &&
                    <pre>{JSON.stringify(this.props.value, null, 4)}</pre>
                }
            </div>
        );
    }
}

JsonView.propTypes = {
    value: PropTypes.any,
    defaultDepth: PropTypes.number,
};
